<template>
  <div class="header">
    <div class="btn-toggle" @click="sidebarToggle">
      <div class="icon">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <img src="../assets/home_logo.png" alt="" class="logo">
  </div>
</template>
<script>

export default {
  name: 'app-header',
  computed: {
    auth () {
      return this.$store.state.auth
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    logout (e) {
      e.preventDefault()
      this.$auth.destroyToken()
      this.$store.state.auth = {}
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue